import React, { useState } from "react";
import "./RegistrationForm.css";

const API_URL = "https://admin.serbiantrophy.rs";

const RegistrationForm = () => {
  const [sending, setSending] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (sending) return;

    // Keep a stable reference to the form BEFORE any await
    const formEl = e.currentTarget;

    const form = new FormData(formEl);
    const payload = Object.fromEntries(form.entries());

    // Ensure category matches backend enum exactly
    if (!["Adventure", "Trophy", "Tourist"].includes(payload.category)) {
      alert("Please choose a valid category.");
      return;
    }

    try {
      setSending(true);
      console.log("Submitting", payload);
      console.log("API URL:", API_URL);
      const res = await fetch(`${API_URL}/api/registrations`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || "Submit failed");
      }

      alert("Registration sent! Check your email for confirmation.");
      formEl.reset(); // use saved ref, not e.currentTarget after await
    } catch (err) {
      console.error(err);
      alert("There was a problem sending your registration. Please try again.");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="registration-container">
      {/* Heading */}
      <div className="registration-header">
        <h3>REGISTRATION</h3>
        <h1>17th Serbian Trophy application</h1>
      </div>

      <div className="registration-content">
        {/* Left copy */}
        <div className="registration-left">
          <p>
            SERBIAN TROPHY is an offroad competition organized by the SERBIA 4×4
            Off-road team.
          </p>
          <p>
            SERBIAN TROPHY is open to anyone interested in a capable off-road
            vehicle.
          </p>
          <p>
            The competition is divided into three categories (classes): TROPHY,
            ADVENTURE (competition classes) and TURIST (revision class). All
            necessary information, radar book, referees, rulebook, and
            everything else necessary for this event is provided by the
            organizer and you can find them on the Privacy policy page. The
            organizer reserves the right to change the hourly schedule provided
            in the invitation letter, as well as to change the rulebook in case
            of unexpected events, but undertakes to inform the participants on
            time (before the start of the first stage).
          </p>
          <p>
            Information about race schedule you can find on the page{" "}
            <a
              href="/about"
              style={{
                color: "#d95d32",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              About the Race
            </a>
          </p>
          <p>All the additional information you need you can get by:</p>
          <div className="additional-info">
            <ul>
              <li>
                <strong>Phone:</strong>{" "}
                <a href="tel:+381600228819">+381 600 22 88 19</a> Darko Tadić -
                Boske
              </li>
              <li>
                <a href="#">Contact form</a>
              </li>
              <li>
                <strong>Email:</strong>{" "}
                <a href="mailto:boske4x4@gmail.com">boske4x4@gmail.com</a>
              </li>
              <li>
                <a href="#">Facebook page</a>
              </li>
              <li>
                <a href="#">Facebook group</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Right form */}
        <div className="registration-right">
          <form onSubmit={handleSubmit}>
            <label>Team name (required)</label>
            <input type="text" name="team" required />

            <label>Vehicle (required)</label>
            <input type="text" name="vehicle" required />

            <label>Category (required)</label>
            <select name="category" required defaultValue="">
              <option value="" disabled>
                Choose category
              </option>
              <option value="Adventure">Adventure</option>
              <option value="Trophy">Trophy</option>
              <option value="Tourist">Tourist</option>
            </select>

            <label>Email (required)</label>
            <input type="email" name="email" required />

            <label>Contact phone number (required)</label>
            <input type="tel" name="phone" required />

            {/* Driver Info */}
            <h3 className="section-title">Driver info:</h3>
            <label>First and Last name (required)</label>
            <input type="text" name="driver_name" required />

            <label>Blood type (required)</label>
            <input type="text" name="driver_blood" required />

            <label>Shirt size (required)</label>
            <select name="driver_shirt" required defaultValue="">
              <option value="" disabled>
                Choose size
              </option>
              <option value="S">S</option>
              <option value="M">M</option>
              <option value="L">L</option>
              <option value="XL">XL</option>
              <option value="XXL">XXL</option>
            </select>

            {/* Co-Driver Info */}
            <h3 className="section-title">Co-driver info:</h3>
            <label>First and Last name (required)</label>
            <input type="text" name="co_driver_name" required />

            <label>Blood type (required)</label>
            <input type="text" name="co_driver_blood" required />

            <label>Shirt size (required)</label>
            <select name="co_driver_shirt" required defaultValue="">
              <option value="" disabled>
                Choose size
              </option>
              <option value="S">S</option>
              <option value="M">M</option>
              <option value="L">L</option>
              <option value="XL">XL</option>
              <option value="XXL">XXL</option>
            </select>

            <button type="submit" disabled={sending}>
              {sending ? "Sending..." : "Submit"}
            </button>

            {/* Debug helper (optional) */}
            {/* <small style={{ display:'block', marginTop:8, opacity:.6 }}>
              Posting to: {API_URL}/api/registrations
            </small> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
